<template>
  <div class="flex space-x-3 align-baseline">
    <UDropdownMenu :items="sortOptions">
      <div class="cursor-pointer flex space-x-1">
        <div>
          Sort by
        </div>
        <svg fill="none" height="16" viewBox="0 0 16 16" width="16"
             xmlns="http://www.w3.org/2000/svg">
          <path
              d="M3.32415 5.68304H12.6757C12.9369 5.68304 13.1478 5.46708 13.1478 5.20592C13.1478 4.94476 12.9369 4.73382 12.6757 4.73382H3.32415C3.05797 4.73382 2.85205 4.94476 2.85205 5.20592C2.85205 5.46708 3.06299 5.68304 3.32415 5.68304ZM4.36377 8.27958H11.6562C11.9173 8.27958 12.1283 8.06362 12.1283 7.80246C12.1283 7.53627 11.9224 7.32534 11.6562 7.32534H4.36377C4.09759 7.32534 3.89167 7.5413 3.89167 7.80246C3.89167 8.05859 4.10261 8.27958 4.36377 8.27958ZM5.3833 10.8711H10.6366C10.9028 10.8711 11.1087 10.6551 11.1087 10.394C11.1087 10.1328 10.9028 9.92188 10.6366 9.92188H5.3833C5.11712 9.92188 4.9112 10.1328 4.9112 10.394C4.9112 10.6551 5.11712 10.8711 5.3833 10.8711Z"
              fill="#1C1C1E"/>
        </svg>
      </div>

      <template #item="{item}">
        <div @click="sort(item.value)" class="cursor-pointer hoover:bg-neutral-200 w-full text-left">
          <p :class="{'underline': item.value === currentSorting}"
               class="uppercase">
            {{ item.label }}
          </p>
        </div>
      </template>

    </UDropdownMenu>
  </div>
</template>

<script lang="ts" setup>

import {useProductsListStore} from "~/store/productsList";

const {setSorting} = useProductsListStore()
const {sortBy, direction} = storeToRefs(useProductsListStore())

const sort = (key: string) => {
  setSorting(key)
}

const currentSorting = computed(() => {
  try {
    return `${sortBy.value}:${direction.value}`
  } catch (e) {
    return ''
  }
})

const sortOptions = [
  {label: 'Newest', value: 'created_at:desc'},
  {label: 'Oldest', value: 'created_at:asc'},
  {label: 'Price: Low to High', value: 'price_cents:asc'},
  {label: 'Price: High to Low', value: 'price_cents:desc'},
]

</script>